import { Component, Injector, OnInit } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { BaseEntityComponent, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Observable, of } from "rxjs";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { CanComponentDeactivate } from "src/app/core/can-deactivate-guard.service";
import { IrregularidadeEmpresaDTO, TipoIrregularidadeEmpresaDTO } from "src/app/model/irregularidade-empresa.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { IrregularidadeEmpresaService } from "../irregularidade_empresa.service";
import { mergeMap, map } from 'rxjs/operators';
import moment from "moment";


@Component({
    selector: 'app-irregularidade-empresa-cadastro',
    templateUrl: './irregularidade_empresa.cadastro.component.html',
    standalone: false
})
export class IrregularidadeEmpresaCadastroComponent
  extends BaseEntityComponent<IrregularidadeEmpresaDTO> implements CanComponentDeactivate {


  formEmpresa :UntypedFormGroup = null;
  private vc: BnConfirmDirective;
  private permissaoEdicao: Boolean;
  public tipos: TipoIrregularidadeEmpresaDTO[] = [];
  tipoIrregularidade: string;
  cnpjEmpresa: string;
  dataInicio: Date;
  dataFim: Date;
  public modoDetalhe: boolean = true;

  constructor(
      private modalService: BnModalMessageService,
      private permissaoService: PermissaoService,
      protected injector: Injector,
      public service: IrregularidadeEmpresaService,
       ) {
        super(service);
        this.config.rotaLista = "irregularidade-empresa/pesquisa";
        this.config.bloquearTelaAoRecuperarModelo = true;
        this.permissaoEdicao = false;
  }


  ngOnInit(){
      this.formEmpresa = this.createReactiveForm();
      this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
          this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
              this.service.buscarTiposIrregularidade().subscribe((tipos) => {
                this.tipos = tipos;
              });
              this.preparaModelo().subscribe((empresa) => {
                  this.setModel(empresa);
                  this.preencheForm(empresa);
              });

      });

  }

  preparaModelo(): Observable<IrregularidadeEmpresaDTO> {
      return this.route.params.pipe(
        mergeMap((params) => {
          if (params['id']) {
            return this.service.buscarPorId(params['id']);
          } else {
              const novo = new IrregularidadeEmpresaDTO();
              this.modoDetalhe = false;
              super.editar();
              return of(novo);
          }
        })
      );
  }


  createReactiveForm(): UntypedFormGroup {
     const form = this.formBuilder.group({


          cnpj:[{value: null}, Validators.required] ,
          dataInicio:[{value: null}, Validators.required] ,
          dataFim: [{value: null}, Validators.required],
          tipo: [{value: null}, Validators.required] ,
      });

      return form;
  }

  preencheForm(model:IrregularidadeEmpresaDTO){
      this.formEmpresa.patchValue({
          cnpj: model.cnpj,
          dataInicio: moment(model.dataInicio).toDate(),
          dataFim: moment(model.dataFim).toDate(),
          tipo: model.tipo?.codigo

      });
  }

  public salvar() {
    this.atualizaModel();
    console.log("model: " + JSON.stringify(this.model));

    this.abreModalConfirmacao('Deseja confirmar o cadastro/atualização da irregularidade?').then(resp => {
      if(resp === true) {
        this.service.salvarOuAtualizar(this.model.tipo?.codigo, this.model).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Irregularidade da empresa criada/atualizada com sucesso'
          })
          this.aposSalvar();
        })
      }
    })
  }

  atualizaModel(){
      let tipoIrregularidade: TipoIrregularidadeEmpresaDTO = new TipoIrregularidadeEmpresaDTO();
      tipoIrregularidade.codigo = this.formEmpresa.get('tipo').value;

      this.model.tipo = tipoIrregularidade;
      this.model.cnpj = this.formEmpresa.get('cnpj').value;
      this.model.dataInicio = this.formEmpresa.get('dataInicio').value; // talvez tenha que formatar..  moment(this.model.dataInicio).format('yyyy-MM-DD')
      this.model.dataFim = this.formEmpresa.get('dataFim').value;
  }

  voltarParaLista() {
    this.abreModalConfirmacao('Descartar alteração?').then(resp => {
      if(resp === true) {
        this.router.navigate(['/irregularidade-empresa/pesquisa']);
      }
    })
  }

  aposSalvar() {
      this.formEmpresa.markAsPristine();
      this.formEmpresa.disable();
      this.modoEdicao = false;
  }

  async verificaSePodeSair(): Promise<boolean> {
      const titulo = 'Confirmação';
      const mensagem = this.model.id!=null ? 'Descartar alterações realizadas?' : 'Descartar novo cadastro de irregularidade?';

      try {
          const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
          return resultadoConfimacao.value === 'ok';
      } catch (e) {
          return false;
      }
  }

  canDeactivate(): Promise<boolean> | boolean {
      if (!this.modoEdicao || this.formEmpresa.valid)
        return true;
      
      return this.verificaSePodeSair();
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }


}
